import MobileIconUi from 'client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { twMerge } from 'tailwind-merge'
import {
  ImageControlStandalone,
  ImageControlStandaloneProps,
} from './image-control-standalone'

interface ImageControlProps extends ImageControlStandaloneProps {
  className?: string
  label?: string
}

export const ImageControl = ({
  label = 'settings_styles.background_image.style',
  className,
  ...props
}: ImageControlProps) => {
  return (
    <OptionWrapper
      directionRow
      labelClassName="text-textPrimary"
      labelText={label}
      labelIcon={props.isMobile && <MobileIconUi />}
      className={twMerge('', className)}
    >
      <ImageControlStandalone {...props} />
    </OptionWrapper>
  )
}
